module.exports.lazyLoading = () => {
    const itemsToEntry = [].slice.call(document.querySelectorAll('.entry'))

    if ('IntersectionObserver' in window) {
        let entryRootMargin = ''
        const itemEntryObserver = new IntersectionObserver(
            function (entries, observer) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        const entryElement = entry.target
                        let itemToEntry = entryElement
                        entryRootMargin = entryElement.dataset.rootMargin
                            ? `${entryElement.dataset.rootMargin} 0px`
                            : '-50px 0px'

                        if (itemToEntry.classList.contains('entry-delay')) {
                            setTimeout(() => {
                                itemToEntry.classList.remove('entry')
                                itemToEntry.classList.add('entered')
                                itemEntryObserver.unobserve(itemToEntry)
                            }, 400)
                        } else {
                            setTimeout(() => {
                                itemToEntry.classList.remove('entry')
                                itemToEntry.classList.add('entered')
                                itemEntryObserver.unobserve(itemToEntry)
                            }, 200)
                        }
                    }
                })
            },
            { rootMargin: entryRootMargin }
        )

        itemsToEntry.forEach(function (itemToEntry) {
            itemEntryObserver.observe(itemToEntry)
        })
    } else {
        itemsToEntry.forEach(function (itemToEntry) {
            itemToEntry.classList.remove('entry')
            itemToEntry.classList.add('entered')
        })
    }

    const lazySliders = [].slice.call(document.querySelectorAll('.splide-lazy'))

    if ('IntersectionObserver' in window) {
        const lazySlideObserver = new IntersectionObserver(
            function (entries, observer) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        let lazySlider = entry.target
                        let lazySlideImages = [].slice.call(
                            lazySlider.querySelectorAll(
                                '.splide-lazy .splide__slide img'
                            )
                        )

                        lazySlideImages.forEach((element) => {
                            if (element.dataset.src) {
                                element.src = element.dataset.src
                            } else {
                                element.srcset = element.dataset.srcset
                            }
                            element.classList.remove('lazy')
                        })

                        lazySlideObserver.unobserve(lazySlider)
                    }
                })
            },
            { rootMargin: '100px 0px' }
        )

        lazySliders.forEach(function (lazySlider) {
            lazySlideObserver.observe(lazySlider)
        })
    }

    const lazyImages = [].slice.call(
        document.querySelectorAll('img.lazy, iframe.lazy')
    )

    if ('IntersectionObserver' in window) {
        const lazyImageObserver = new IntersectionObserver(
            function (entries, observer) {
                entries.forEach(function (entry) {
                    let lazyImage = entry.target

                    if (
                        entry.isIntersecting &&
                        lazyImage.classList.contains('lazy')
                    ) {
                        if (lazyImage.dataset.src) {
                            lazyImage.src = lazyImage.dataset.src
                        } else {
                            lazyImage.srcset = lazyImage.dataset.srcset
                        }
                        lazyImageObserver.unobserve(lazyImage)
                        lazyImage.classList.remove('lazy')
                    }
                })
            },
            { rootMargin: '100px 0px' }
        )

        lazyImages.forEach(function (lazyImage) {
            lazyImageObserver.observe(lazyImage)
        })
    } else {
        lazyImages.forEach(function (lazyImage) {
            if (lazyImage.dataset.src) {
                lazyImage.src = lazyImage.dataset.src
            } else if (lazySlideImg.dataset.srcset) {
                lazyImage.srcset = lazyImage.dataset.srcset
            }
        })
    }

    const lazyBgImages = [].slice.call(
        document.querySelectorAll('div[data-style]')
    )

    if ('IntersectionObserver' in window) {
        const lazyBgImageObserver = new IntersectionObserver(
            function (entries, observer) {
                entries.forEach(function (entry) {
                    let lazyBgImage = entry.target

                    if (
                        entry.isIntersecting &&
                        lazyBgImage.classList.contains('lazy')
                    ) {
                        lazyBgImage.setAttribute(
                            'style',
                            lazyBgImage.dataset.style
                        )
                        lazyBgImageObserver.unobserve(lazyBgImage)
                        lazyBgImage.classList.remove('lazy')
                    }
                })
            },
            { rootMargin: '300px 0px' }
        )

        lazyBgImages.forEach(function (lazyBgImage) {
            lazyBgImageObserver.observe(lazyBgImage)
        })
    } else {
        lazyBgImages.forEach(function (lazyBgImage) {
            if (lazyBgImage.dataset.style) {
                lazyBgImage.setAttribute('style', lazyBgImage.dataset.poster)
            }
        })
    }

    const itemsToOverlay = [].slice.call(
        document.querySelectorAll('.is-overlay')
    )

    if ('IntersectionObserver' in window) {
        const itemOverlayObserver = new IntersectionObserver(
            function (entries, observer) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        let itemToOverlay = entry.target

                        if (itemToOverlay.classList.contains('overlay-delay')) {
                            setTimeout(() => {
                                itemToOverlay.classList.add('active')
                                itemOverlayObserver.unobserve(itemToOverlay)
                            }, 1000)
                        } else {
                            setTimeout(() => {
                                itemToOverlay.classList.add('active')
                                itemOverlayObserver.unobserve(itemToOverlay)
                            }, 500)
                        }
                    }
                })
            },
            { rootMargin: '-100px 0px' }
        )

        itemsToOverlay.forEach(function (itemToOverlay) {
            itemOverlayObserver.observe(itemToOverlay)
        })
    } else {
        itemsToOverlay.forEach(function (itemToOverlay) {
            itemToOverlay.classList.add('active')
        })
    }
}
